import * as React from 'react';
import { connect } from 'react-redux';
import { FestivalOverviewSettingsModel } from '../redux/reducers/settings-reducer';
import { FestivalOverviewAppState } from '../classes/redux-states';
import { getSettings, getFestivalSeries, updatePageId } from '../redux/actions/festival-overview-api';
import { Dispatch } from 'redux';
import SeriesListComponent from './series-list';
import { LoadingComponent } from './loading-state';
import FestivalInfoComponent from './festival-info';
import DayListComponent from './day-navigation/day-nav-container';
import SeriesListContainerComponent from './series-list-container';
import { has } from 'lodash';

interface StateToProps {
    settings: FestivalOverviewSettingsModel;
    state: FestivalOverviewAppState;
    requestingData: boolean;
}

interface DispatchToProps {
    getSettings: (pageId: string) => any;
    getFestivalSeries: (day: string) => any;
    updatePageId: (pageId: string) => any;

}

type FestivalOverviewContainerProps = StateToProps & DispatchToProps;

export class FestivalOverviewContainer extends React.Component<FestivalOverviewContainerProps> {
    constructor(props: FestivalOverviewContainerProps) {
        super(props);
        this.getResults = this.getResults.bind(this);
        this.getFestivalSeriesMarkup = this.getFestivalSeriesMarkup.bind(this);
        var pageId = (document.getElementById("pageId") as HTMLInputElement).value;
        this.props.updatePageId(pageId);
        this.props.getSettings(pageId);
        this.getResults();
    }


    getResults() {
        var dayFromQueryString = this.getDayQueryStringParam();
        if (dayFromQueryString !== null && dayFromQueryString !== '') {
            this.props.getFestivalSeries(dayFromQueryString);
        }
        else {
            this.props.getFestivalSeries(this.props.settings.currentDay);
        }
    }

    getDayQueryStringParam() {
        var dayQueryString = this.getURLParam("day") as string;
        return dayQueryString;
    }

    getURLParam(name) {
        var queryStringParam = new RegExp('[\?&]' + name + '=([^&#]*)').exec(window.location.href); // gets a specific value from the location object's URL and filters out any symbols that may be in the URL
        if (queryStringParam == null) {
            return null;
        }
        else {
            return decodeURI(queryStringParam[1]) || 0;
        }
    }

    componentDidMount() {
        this.getDayQueryStringParam();
    }


    getFestivalSeriesMarkup() {

        return this.props.requestingData ? <LoadingComponent /> : <SeriesListContainerComponent seriesList={this.props.state.festivalOverviewApiModel.seriesList} dayLabel={this.props.state.festivalOverviewApiModel.dayLabel} />;

    }

    render() {
        return (
            <div>

                <DayListComponent />

                <div className="season-overview">
                    {this.getFestivalSeriesMarkup()}
                </div>
            </div>
        )
    }
}


function mapStateToProps(state: FestivalOverviewAppState): StateToProps {
    return {
        settings: state.festivalOverviewSettingsModel,
        requestingData: state.festivalOverviewApiModel.requestingData,
        state: state
    }
}

function mapDispatchToProps(dispatch: Dispatch<FestivalOverviewAppState>): DispatchToProps {
    return {
        getSettings: (pageId: string) => dispatch(getSettings(pageId)),
        getFestivalSeries: (day: string) => dispatch(getFestivalSeries(day)),
        updatePageId: (pageId: string) => dispatch(updatePageId(pageId)),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(FestivalOverviewContainer);